import React from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import AsyncComponentError from '../Error/AsyncComponentError';

const TSVideoProvider = ({ ariaLabelledBy, ...restProps }) => {
    return (
        <AsyncComponent
            appName="twig-video-mfe"
            componentName="VideoProvider"
            errorComponent={AsyncComponentError}
            ariaLabelledBy={ariaLabelledBy}
            {...restProps}
        />
    );
};

export default TSVideoProvider;
